import { IntegrationPermission } from "./integration-permission";

export class IntergrationPermissionListing{
    public admin: boolean = false;
    public integrations : IntegrationPermission[] = [];
}